<template>
  <b-container data-app fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="ri-search-line"></i>
              {{ $t("public.views.Pages.Professional.Admin.Sessions.filter") }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button class="mr-2" style="right" variant="primary" @click="goToSessionsOlds">Antiguas
            </b-button>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="professionals">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.professionalLead"
                    )
                  }}:
                  </template>

                  <multiselect v-model="filter.professionalLeads" :clear-on-select="false" :close-on-select="false"
                    :multiple="true" :options="professionalsFilterSelect" :preselect-first="true" :preserve-search="true"
                    label="text" track-by="value" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectedLabel'
  )
" @input="changeFilter">
                    <template slot="option" slot-scope="props">
                      <b-list-group-item class="d-flex align-items-center">
                        <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                        <span class="mr-auto title-typography-color">{{
                          props.option.text
                        }}</span>
                      </b-list-group-item>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                        class="multiselect__single">{{ values.length }}
                        {{
                          $t(
                            "public.views.Pages.Professional.Admin.Sessions.selectedProfessionals"
                          )
                        }}</span></template>
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="professionals">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.professional"
                    )
                  }}:
                  </template>

                  <multiselect v-model="filter.professionals" :clear-on-select="false" :close-on-select="false"
                    :multiple="true" :options="professionalsFilterSelect" :preselect-first="true" :preserve-search="true"
                    label="text" track-by="value" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectedLabel'
  )
" @input="changeFilter">
                    <template slot="option" slot-scope="props">
                      <b-list-group-item class="d-flex align-items-center">
                        <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                        <span class="mr-auto title-typography-color">{{
                          props.option.text
                        }}</span>
                      </b-list-group-item>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                        class="multiselect__single">{{ values.length }}
                        {{
                          $t(
                            "public.views.Pages.Professional.Admin.Sessions.selectedProfessionals"
                          )
                        }}</span></template>
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="patients">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.contact"
                    )
                  }}:
                  </template>
                  <multiselect v-model="filter.patients" :clear-on-select="false" :close-on-select="false"
                    :loading="isLoadingPatients" :multiple="true" :options="patientsFilterSelect" :preselect-first="true"
                    :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectedLabel'
  )
" @input="changeFilter" @search-change="getAllPatients">
                    <template slot="noResult">
                      {{ $t("generic.noResults") }}
                    </template>
                    <template slot="noOptions">
                      {{ $t("generic.min3") }}
                    </template>
                    <template slot="option" slot-scope="props">
                      <b-list-group-item class="d-flex align-items-center">
                        <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                        <span class="mr-auto title-typography-color">{{
                          props.option.text
                        }}</span>
                      </b-list-group-item>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                        class="multiselect__single">{{
                          values.length
                        }}{{
  $t(
    "public.views.Pages.Professional.Admin.Sessions.selectedContacts"
  )
}}</span></template>
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="dateAfter">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.dateBefore"
                    )
                  }}:
                  </template>
                  <date-picker v-model="filter.startTo" :format="myFormat" :formatter="momentFormat" class="w-100"
                    type="date" @input="changeFilter"></date-picker>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="dateAfter">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.dateAfter"
                    )
                  }}:
                  </template>
                  <date-picker v-model="filter.startFrom" :format="myFormat" :formatter="momentFormat" class="w-100"
                    type="date" @input="changeFilter"></date-picker>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="dateAfter">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.modality"
                    )
                  }}:
                  </template>
                  <b-form-select v-model="filter.online" :options="paidSelect" type="text" @input="changeFilter">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="hasInvoice">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.hasInvoice"
                    )
                  }}:
                  </template>
                  <b-form-select v-model="filter.invoice" :options="invoiceSelect" type="text" @input="changeFilter">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="paid">
                  <template slot="label">
                    {{
                      $t("public.views.Pages.Professional.Admin.Sessions.paid")
                    }}:
                  </template>
                  <b-form-select v-model="filter.paid" :options="yesOrNoSelect" type="text" @input="changeFilter">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="canceled">
                  <template slot="label">
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Sessions.canceled"
                      )
                    }}:
                  </template>
                  <b-form-select v-model="filter.deleted" :options="yesOrNoSelect" @input="changeFilter">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="visitType">
                  <template slot="label">
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Sessions.visitType"
                      )
                    }}:
                  </template>

                  <multiselect v-model="filter.visitTypes" :clear-on-select="false" :close-on-select="false"
                    :multiple="true" :options="visitTypeSelect" :preselect-first="true" :preserve-search="true"
                    label="text" track-by="value" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.placeholder3'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectedLabel'
  )
" @input="changeFilter">
                    <template slot="option" slot-scope="props">
                      <b-list-group-item class="d-flex align-items-center">
                        <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i><span
                          class="mr-auto title-typography-color">{{
                            props.option.text
                          }}</span>
                      </b-list-group-item>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                        class="multiselect__single">{{ values.length }}
                        {{
                          $t(
                            "public.views.Pages.Professional.Admin.Sessions.selectedVisitType"
                          )
                        }}</span></template>
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col v-if="!organization || organization.isGalatea" lg="3" md="3" sm="6" xl="3">
                <b-form-group label-for="codeGalatea">
                  <template slot="label">{{
                    $t(
                      "public.views.Pages.Professional.Admin.Sessions.codeGalatea"
                    )
                  }}:
                  </template>
                  <b-form-input id="codeGalatea" v-model="filter.codeGalatea" type="text"
                    @blur="changeFilter"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-comments"></i>
              {{
                $t("public.views.Pages.Professional.Admin.Sessions.sessions")
              }}
            </h4>
          </template>
          <template v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getSessionsExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="sessions" :options.sync="pagination" :server-items-length="total"
                item-key="name">
                <template v-slot:item.date="{ item }">
                  {{ new Date(item.startedAt).toLocaleString() }}
                </template>
                <template v-slot:item.modality="{ item }">
                  <span v-if="item.eventPlace === 'ONLINE'" class="badge badge-success">{{
                    $t("generic.online")
                  }}</span>
                  <span v-else class="badge badge-danger">{{
                    $t("generic.offline")
                  }}</span>
                </template>
                <template v-slot:item.hasInvoice="{ item }">
                  <span v-for="(billing, index) in item.billings" v-bind:key="index">
                    <b-badge v-if="billing.invoices && billing.invoices.length !== 0" class="mr-2" variant="success">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                    <b-badge v-else class="mr-2" variant="danger">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                  </span>
                </template>
                <template v-slot:item.hasProfessionalLead="{ item }">
                  <b-list-group-item v-if="item.professionalLead" class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      item.professionalLead.avatarUrl
                        ? item.professionalLead.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">
                        {{ item.professionalLead.name }}
                      </p>
                      <p class="mb-0 font-size-12">
                        {{ item.professionalLead.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.hasProfessionals="{ item }">
                  <b-list-group-item v-for="(professional, index) in item.professionals" v-bind:key="index"
                    class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      professional.avatarUrl
                        ? professional.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ professional.name }}</p>
                      <p class="mb-0 font-size-12">
                        {{ professional.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.hasPatients="{ item }">
                  <b-list-group-item v-for="(patient, index) in item.patients" v-bind:key="index"
                    class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      patient.avatarUrl
                        ? patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ patient.name }}</p>
                      <p class="mb-0 font-size-12">{{ patient.lastname }}</p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.visitType="{ item }">
                  <i :style="'color: ' + item.visitType.colour" class="fas fa-circle mr-2"></i>
                  {{ item.visitType.name }}
                </template>
                <template v-slot:item.isPay="{ item }">
                  <span v-for="(billing, index) in item.billings" v-bind:key="index">
                    <b-badge v-if="billing.payment" class="mr-2" variant="success">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                    <b-badge v-else class="mr-2" variant="danger">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                  </span>
                </template>
                <template v-slot:item.canceled="{ item }">
                  <span v-if="!item.deletedAt" class="badge badge-success">{{
                    $t("generic.no")
                  }}</span>
                  <span v-else class="badge badge-danger">{{
                    $t("generic.yes")
                  }}</span>
                </template>
                <template v-slot:item.totalMinutes="{ item }">
                  <span v-if="item.finishedAt" class="badge badge-danger">{{
                    $t("generic.noStarted")
                  }}</span>
                  <span v-else>{{ item.totalMinutes }}</span>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import { mapActions, mapGetters } from "vuex";

import moment from "moment";
import { saveAs } from "file-saver";

import OnlineOrOfflineFilterSelect from "../../../../json/filter/OnlineOrOfflineFilterSelect";
import InvoiceOrNotFilterSelect from "../../../../json/filter/InvoiceOrNotFilterSelect";
import YesOrNoFilterSelect from "../../../../json/filter/YesOrNoFilterSelect";
import PaymentPlaceFilterSelect from "../../../../json/filter/PaymentPlaceFilterSelect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import utilsService from "../../../../services/utils";
import scheduleService from "../../../../services/schedule";
import patientService from "../../../../services/patient";
import professionalService from "../../../../services/professional";
import organizationService from "../../../../services/organization";

export default {
  name: "Session",
  computed: {
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
  },
  mounted() {
    xray.index();
    this.getAllSessions();
    this.getAllProfessionals();
    this.getAllVisitType();
    this.getOrganization();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SESSIONS", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllSessions();
        }
        this.start = true;
      },
    },
  },
  methods: {
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response) {
            self.organization = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "view-pages-professional-admin-sessions",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            })
          });
        },
        " "
      );
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    goToSessionsOlds() {
      this.$router.push({
        name: "auth.professional.admin.sessionsOld",
      });
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    getSessionsExcel() {
      let data = this.cloneFilterSend();

      if (this.organization && this.organization.isGalatea) {
        this.$awn.asyncBlock(
          scheduleService.getAllEventsAndDeletePerformanceGalateaExcel(data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SESSIONS_EXCEL", info: "" });
              saveAs(response.data, "sessions.xlsx");
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "scheduleService.getAllEventsAndDeletePerformanceGalateaExcel",
              module: "view-pages-professional-admin-sessions",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              })
            });
          },
          " "
        );
      } else {
        this.$awn.asyncBlock(
          scheduleService.getAllEventsAndDeletePerformanceExcel(data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SESSIONS_EXCEL", info: "" });
              saveAs(response.data, "sessions.xlsx");
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "scheduleService.getAllEventsAndDeletePerformanceExcel",
              module: "view-pages-professional-admin-sessions",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              })
            });
          },
          " "
        );
      }
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    changeFilter() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getAllSessions();
    },
    cloneFilterSend() {
      let clone = JSON.parse(JSON.stringify(this.filter));

      //Professionals lead

      if (clone.professionalLeads) {
        let professionalLeadREST = [];
        clone.professionalLeads.forEach(function (professional) {
          professionalLeadREST.push(professional.value);
        });
        clone.professionalLeads = professionalLeadREST;
      } else {
        clone.professionalLeads = [];
      }

      //Professionals

      if (clone.professionals) {
        let professionalREST = [];
        clone.professionals.forEach(function (professional) {
          professionalREST.push(professional.value);
        });
        clone.professionals = professionalREST;
      } else {
        clone.professionals = [];
      }

      //Patients

      if (clone.patients) {
        let patientsREST = [];
        clone.patients.forEach(function (patient) {
          patientsREST.push(patient.value);
        });
        clone.patients = patientsREST;
      } else {
        clone.patients = [];
      }

      // StartAt
      if (clone.startTo) {
        clone.startTo = moment(clone.startTo)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startTo = null;
      }

      if (clone.startFrom) {
        clone.startFrom = moment(clone.startFrom)
          .set("hour", 24)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startFrom = null;
      }

      // Online
      if (clone.online) {
        if (clone.online === "ALL") {
          clone.online = null;
        } else if (clone.online === "ONLINE") {
          clone.online = true;
        } else if (clone.online === "OFFLINE") {
          clone.online = false;
        } else {
          clone.online = null;
        }
      } else {
        clone.online = null;
      }

      // Invoice
      if (clone.invoice) {
        if (clone.invoice === "ALL") {
          clone.invoice = null;
        } else if (clone.invoice === "WITHOUT_INVOICE") {
          clone.invoice = false;
        } else if (clone.invoice === "WITH_INVOICE") {
          clone.invoice = true;
        } else {
          clone.invoice = null;
        }
      } else {
        clone.invoice = null;
      }

      // Paid
      if (clone.paid) {
        if (clone.paid === "ALL") {
          clone.paid = null;
        } else if (clone.paid === "YES") {
          clone.paid = true;
        } else if (clone.paid === "NO") {
          clone.paid = false;
        } else {
          clone.paid = null;
        }
      } else {
        clone.paid = null;
      }

      // Deleted
      if (clone.deleted) {
        if (clone.deleted === "ALL") {
          clone.deleted = null;
        } else if (clone.deleted === "YES") {
          clone.deleted = true;
        } else if (clone.deleted === "NO") {
          clone.deleted = false;
        } else {
          clone.deleted = null;
        }
      } else {
        clone.deleted = null;
      }

      // VisitType
      if (clone.visitTypes && clone.visitTypes.length !== 0) {
        let visitTypeResult = [];
        clone.visitTypes.forEach(function (item) {
          visitTypeResult.push(item.value);
        });

        clone.visitTypes = visitTypeResult;
      } else {
        clone.visitTypes = null;
      }

      return clone;
      //
    },
    async getAllSessions() {
      let self = this;

      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        scheduleService.getAllEventsAndDeletePerformance(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          self.sessions = response.data.content;
          self.total = response.data.pageable.total;
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllEventsAndDeletePerformance",
            module: "view-pages-professional-admin-sessions",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                colour: item.colour,
                value: item.id,
                text: item.name,
              });
            });
            self.visitTypeSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllVisitTypeActive",
            module: "view-pages-professional-admin-sessions",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    async getAllPatients(query) {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;
        patientService
          .getAll(query)
          .then((response) => {
            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text:
                  item.name + " " + item.lastname + " (" + item.document + ") ",
              };
              combo.push(data);
            });
            self.patientsFilterSelect = combo;
            self.isLoadingPatients = false;
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-admin-sessions",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                query: query
              })
            });
            self.isLoadingPatients = false;
          });
      }
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAll()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              uuid: item.uuid,
              value: item.id,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-professional-admin-sessions",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.date"
          ),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.modality"
          ),
          value: "modality",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.hasInvoice"
          ),
          value: "hasInvoice",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.hasPatients"
          ),
          value: "hasPatients",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.hasProfessionalLead"
          ),
          value: "hasProfessionalLead",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.hasProfessionals"
          ),
          value: "hasProfessionals",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.visitType"
          ),
          value: "visitType",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.isPay"
          ),
          value: "isPay",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.canceled"
          ),
          value: "canceled",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Sessions.headers.totalMinutes"
          ),
          value: "totalMinutes",
        },

        //{ text: "Acciones", value: "id" },
      ],
      isLoadingPatients: false,
      start: false,
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,

      sessions: [],
      //Filter
      filter: {
        professionalLeads: [],
        professionals: [],
        patients: [],
        startTo: null,
        startFrom: null,
        online: null,
        invoice: null,
        paid: null,
        deleted: null,
        visitTypes: null,
        codeGalatea: null,
      },
      //Select filter
      paidSelect: OnlineOrOfflineFilterSelect,
      invoiceSelect: InvoiceOrNotFilterSelect,
      yesOrNoSelect: YesOrNoFilterSelect,
      paymentPlace: PaymentPlaceFilterSelect,
      patientsFilterSelect: [],
      professionalsFilterSelect: [],
      visitTypeSelect: [],
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      //Galatea
      organization: undefined,
    };
  },
  components: {
    DatePicker,
    multiselect: Multiselect,
  },
};
</script>
